import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex flex-wrap" }

import { PropType } from "vue";
import { HIERARCHY_TAGS_META } from "@/constants/hierarchyTags";
import { HierarchyType } from "@/types/HierarchyTag";


export default /*#__PURE__*/_defineComponent({
  __name: 'LocationTag',
  props: {
  data: {
    required: true,
    type: Object,
  },
  field: {
    required: true,
    type: String as PropType<HierarchyType>,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(__props.data), (tag) => {
      return (_openBlock(), _createElementBlock(_Fragment, { key: tag }, [
        (__props.data[tag])
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass([
          'px-2 py-0.5 m-1 cursor-pointer rounded-md align-middle text-xs whitespace-nowrap flex',
          _unref(HIERARCHY_TAGS_META)[tag as HierarchyType].bgLight,
          _unref(HIERARCHY_TAGS_META)[tag as HierarchyType].text,
        ])
            }, _toDisplayString(__props.data[tag]), 3))
          : _createCommentVNode("", true)
      ], 64))
    }), 128))
  ]))
}
}

})